// Add your custom JS here.
import LazyLoad from 'vanilla-lazyload';

var lazyLoadInstance = new LazyLoad();
lazyLoadInstance;